import React from 'react';

interface ICheckmarkProps {
  width?: string | number;
  height?: string | number;
}

export const IconCheckmark: React.FC<ICheckmarkProps> = props => (
  <svg data-dir="ltr" width="65px" height="65px" viewBox="0 0 65 65" {...props}>
    <title>checkmark</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-154.000000, -102.000000)">
        <g transform="translate(154.000000, 102.000000)">
          <circle fill="#BE5A09" cx="32.5" cy="32.5" r="32.5" />
          <path
            d="M43.846336,22.0511396 C44.8684343,20.8201474 46.7019052,20.6450499 47.9415079,21.6600486 C49.1334336,22.6360088 49.3422967,24.3569179 48.4479582,25.5821994 L48.3353346,25.7267748 L31.5448065,45.94891 C30.4984776,47.2090851 28.6206881,47.3504913 27.3962367,46.2953561 L27.2629507,46.1731908 L17.8717277,37.0231005 C16.7248961,35.9057154 16.707361,34.0766629 17.832562,32.9377974 C18.9127549,31.8444865 20.6534081,31.7847059 21.8055753,32.7702636 L21.9464408,32.8989037 L29.0736668,39.8432589 L43.846336,22.0511396 Z"
            fill="#FFFFFF"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);
